const STORAGE_KEY = "chesshotel:puzzle-guest:v1";
let memoryToken: string | null = null;

export function guestToken() {
  if (memoryToken) return memoryToken;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && /^[a-f0-9]{64}$/.test(stored)) return memoryToken = stored;
  } catch { /* Storage may be disabled; this tab can still play. */ }
  memoryToken = Array.from(crypto.getRandomValues(new Uint8Array(32)), (byte) => byte.toString(16).padStart(2, "0")).join("");
  try { localStorage.setItem(STORAGE_KEY, memoryToken); } catch { /* Keep the in-memory session. */ }
  return memoryToken;
}

export function clearGuestToken() {
  memoryToken = null;
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* No persistent storage. */ }
}
